<template>
  <a-popover :title="false" v-if="!textMode">
    <template slot="content">
      <div class="p-all">
        <div>
          <img
            v-if="tool.hotkey"
            :src="require('@/assets/images/' + tool.hotkey.icon)"
            class="m-r"
          />
          {{ $t(tool.id) }}
        </div>
        <div v-if="tool.about">
          <a-divider />
          {{ tool.about }}
        </div>
      </div>
    </template>
    <span
      class="tool-group-btn without-arrow"
      v-bind:class="{
        'tool-group-btn__active': isToolActive,
        'tool-group-btn__disabled': disabled,
      }"
      @click="setToolActive"
    >
      <span class="tool-group-btn__item tool-group-btn__icon">
        <i
          class="fa-light"
          aria-hidden="true"
          v-bind:class="{ [tool.icon]: true }"
        ></i>
      </span>
    </span>
  </a-popover>
  <a-list-item-meta @click="setToolActive" v-else>
    <div slot="description">
      <div>{{ $t(tool.id) }}</div>
      <div v-if="tool.about" class="dash-text__10 dash-text__300">
        {{ tool.about }}
      </div>
    </div>

    <i
      slot="avatar"
      class="fa-light dash-icon"
      aria-hidden="true"
      v-bind:class="{ 'dash-icon__active': isToolActive, [tool.icon]: true }"
    ></i>
  </a-list-item-meta>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    tool: {
      required: true,
      type: Object,
    },
    textMode: {
      required: false,
      type: Boolean,
      default: false,
    },
    group_id: {
      required: false,
      type: String,
      default: "",
    },
    deselect: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  beforeDestroy() {
    this.$root.$off("newActiveCanvas", this.newActiveCanvas);
  },
  created() {
    this.$accessModule(this.tool.id, this);
    this.$root.$on("newActiveCanvas", this.newActiveCanvas);
  },
  computed: {
    ...mapGetters(["activeTools", "isMobile"]),
    tool_id() {
      return this.tool.old_id && this.isMobile
        ? this.tool.old_id
        : this.tool.id;
    },
    isToolActive() {
      return this.activeTools.indexOf(this.tool_id) !== -1;
    },
  },
  methods: {
    newActiveCanvas(canvas) {
      this.disabled = canvas.type === "STACK" && this.tool.seg_type;
    },
    setToolActive() {
      if (this.disabled) {
        return;
      }
      this.$store.dispatch("tooglePopover", {
        tool_id: this.group_id,
        enable: false,
      });
      if (this.tool.id === "Reset") {
        this.$root.$emit("resetAllTools");
        return;
      }
      if (this.tool.id === "Screen") {
        this.$root.$emit("downloadAllImages");
        return;
      }
      if (this.tool.id === "Flip") {
        this.$root.$emit("flipViewport", "flip");
        return;
      }
      if (this.tool.id === "Rotate") {
        this.$root.$emit("rotateViewport", "rotate");
        return;
      }
      if (!this.deselect && this.isToolActive) {
        return;
      } else if (this.tool_id === "Crosshairs") {
        if (this.isToolActive) {
          this.$root.$emit("disableCrosshairsTool");
        }
        this.$store.dispatch("updateCrosshairsTool", !this.isToolActive);
      } else {
        this.$store.dispatch(
          "updateActiveTools",
          this.isToolActive
            ? this.activeTools.filter((tool) => {
                return tool !== this.tool_id;
              })
            : this.activeTools
                .filter((tool) => {
                  return tool === "StackScrollMouseWheel";
                })
                .concat([this.tool_id])
        );
      }
    },
  },
};
</script>
